import { render, staticRenderFns } from "./BackToLink.vue?vue&type=template&id=1b4585d8"
import script from "./BackToLink.vue?vue&type=script&lang=ts"
export * from "./BackToLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports